


































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import {AloArbo, getDefaultAloArbo} from '@/models/alo/AloArbo'
import {loadLanguageAsync} from '@/locale/vueI18n'  
import { ItemPanier } from '@/models/alo/ItemPanier';

@Component({
  name: 'CarteRoomService',
  props:{
    sectionId:{
      type:Number,
      default:-1
    },
    pageId:{
      type:Number,
      default:-1
    },
    canAddFromArbo:{
      type:Function,
      default:(arbo:AloArbo) => false
    } 
  }
})
export default class CarteRoomService extends Vue {
   
  sectionId!:number
  pageId!:number
  selectedSectionIdx:number = 0
  selectedPageIdx:number = 0
  canAddFromArbo!:Function

  monType = "plat-section"
  
  mounted() {    
    //recherche si on doit se mettre sur une section en particulié    
    const idx = this.arbosList.findIndex(a => a.id == this.sectionId)
    if(idx > -1) this.section = idx              
    else this.section =  Math.max(this.arbosList.findIndex(a => a.isDefault),0)
  }

  get printMode(){
    return this.$store.myGetters.printMode
  }

  get defaultPageIdx() {
    const idx = this.subMenus.findIndex(a => a.id == this.pageId)
    if(idx > -1) return idx              
    else return Math.max(this.subMenus.findIndex(a => a.isDefault) ?? 0,0)
  }

  private get arbosDic(){
    return this.$store.myGetters.arbosDic
  }

  private get platsDic(){
    return this.$store.myGetters.platsDic
  }

  private get arbosList():Array<AloArbo> {   
    return this.$store.myGetters.arbosList
  }

  get section(){
    return this.selectedSectionIdx
  }

  set section(value) {    
    this.selectedSectionIdx = value    
    this.page = this.defaultPageIdx
  }

  get page(){
    return this.selectedPageIdx
  }
  set page(value) {
    this.selectedPageIdx = value 
  }

  get selectedGroup(){
    return this.arbosList[this.selectedSectionIdx] || getDefaultAloArbo()
  }

  get subMenus(){
    return this.selectedGroup.childrenIds?.map(id => this.arbosDic[id]) ?? []
  }
  

  addToCart(itemPanier:ItemPanier) {
    this.$emit('addToCart',itemPanier);    
  }
  

}
